// @ts-nocheck
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(productDescriptionStyles, {
    productDetailLink: {
        typographyProps: {
            css: css`
                line-height: ${({ theme }) => theme.design.typography.lineHeight.small};
            `,
        },
    },
    productDetailDescription: {
        css: css`
            line-height: ${({ theme }) => theme.design.typography.lineHeight.small};
        `,
    },
});
